import { Controller } from "@hotwired/stimulus"
import Keyboard from "simple-keyboard"
import layout from "simple-keyboard-layouts/build/layouts/arabic";

// Connects to data-controller="keyboard"
export default class extends Controller {
  connect() {
    this.keyboard = new Keyboard({
      onChange: input => this.onChange(input),
      onKeyPress: button => this.onKeyPress(button),
      ...layout,
      rtl: false
    });

    this.input = document.querySelector(`.${this.element.dataset.inputClass}`);

    this.onInputChange();
  }

  onInputChange() {
    this.input.addEventListener("input", event => {
      this.keyboard.setInput(event.target.value);
    });
  }

  offInputChange() {
    this.input.removeEventListener("input", event => {
      this.keyboard.setInput(event.target.value);
    });
  }

  onChange(input) {
    this.input.value = input;
  }

  onKeyPress(button) {
    /**
     * If you want to handle the shift and caps lock buttons
     */
    if (button === "{shift}" || button === "{lock}") this.handleShift();
  }

  handleShift() {
    let currentLayout = this.keyboard.options.layoutName;
    let shiftToggle = currentLayout === "default" ? "shift" : "default";

    this.keyboard.setOptions({
      layoutName: shiftToggle
    });
  }

  disconnect() {
    this.keyboard.destroy();
    this.offInputChange();
  }
}
